import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { AppStateService } from './state.service';
import { Config } from '../_store/config';
import { PostProcessHttpResponseService } from './post-process-http-response.service';


@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  private localHttp: HttpClient;
  
  constructor(
    private http: HttpClient,
    private appStateService: AppStateService,
    handler: HttpBackend,
    private postProcessResp: PostProcessHttpResponseService
  ) {
    this.localHttp = new HttpClient(handler);
  }

  private setAppBusy(isBusy) {
    this.appStateService.setAppStateAttribute('appBusy', isBusy);
  }

  private getDefaultHeaders() {
    let header = new HttpHeaders().set('Accept', 'text/html, application/xhtml+xml, */*').set('Content-Type', 'application/json');
    return header;
  }

  httpPost(req, reqURL, options: any = {}): Observable<any> {
    if (options.responseType) {
      let header = this.getDefaultHeaders();
      return this.http.post(reqURL, req, { headers: header, responseType: options.responseType });
    }
    this.setAppBusy(true);
    return this.http.post(reqURL, req, options).pipe(
      map(
        response => {
          this.setAppBusy(false);
          this.postProcessResp.processResponse(reqURL, response);
          return response;
        }
      )
    );
  }


  httpGet(reqURL, options): Observable<any> {
    this.setAppBusy(true);
    return this.http.get(reqURL, options).pipe(
      map(
        response => {
          this.setAppBusy(false);
          return response;
        }
      )
    );
  }

  httpMultiPart(reqURL, req) {
    this.setAppBusy(true);
    const headers = new HttpHeaders();
    return this.localHttp.post(reqURL, req).pipe(
      map(
        response => {
          this.setAppBusy(false);
          return response;
        }
      )
    );
  }

  httpGetLocal(url, options = {}) {
    return this.localHttp.get(url, options);
  }
}
